/* eslint-disable react/button-has-type */
/* eslint-disable no-return-assign */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'gatsby'
import '../css/navbar.scss'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import india from '../img/landing/india.png'
import Logo from '../img/landing/logo.svg'
import { serviceIconLookup } from '../utils/react_helper'


export const menuItems = [
  { name: 'Physiotherapy', page: 'physiotherapy/' },
  { name: 'Nursing', page: 'nursing/' },
  {
    name: 'Medical Equipment',
    page: 'medical-equipment/',
  },
  { name: 'Trained Attendants', page: 'trained-attendants/' },
  { name: 'Lab Tests', page: 'diagnostic/' },
  { name: 'Elder Care', page: 'elder-care/' },
  { name: 'Doctor Consultation', page: 'doctor-consultations/' },
  {
    name: 'Mother & Baby Care',
    page: 'new-born-baby-mother-care/',
  },
  { name: 'Diabetes Care', page: 'diabetes-care/' },
  { name: 'Critical Care', page: 'critical-care/' },
  { name: 'Covid Care', page: 'coronavirus/' },
  { name: 'Vaccination', page: 'vaccination/' },
  { name: 'Counselling', page: 'counselling/' },
  {
    name: 'Nutrition & Diet Consultation',
    page: 'nutrition-diet-consultation/',
  },
]
function NavBar({ enableModal }) {
  const [slider, setslider] = useState(false)
  const [animslider, setanimslider] = useState(false)
  const [menu, setmenu] = useState(true)
  const [isactive, setisactive] = useState(false)
  const [ismenu, setismenu] = useState(false)
  const navbarRef = useRef(null)
  const navAction = () => {
    const scroll = document.documentElement.scrollTop
    const hei = document
      .getElementsByClassName('nav-section')[0]
      .getBoundingClientRect().height
    if (scroll >= hei) {
      setisactive(true)
    } else {
      setisactive(false)
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', navAction)

    return () => {
      window.removeEventListener('scroll', navAction)
    }
  }, [])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navbarRef.current && !navbarRef.current.contains(e.target)) {
        setismenu(false)
      }
    }
    const scrollHide = () => {
      setismenu(false)
    }
    if (ismenu) {
      window.addEventListener('scroll', scrollHide)
      window.addEventListener('mousedown', handleClickOutside)
    }
    return () => {
      window.removeEventListener('mousedown', handleClickOutside)
      window.removeEventListener('scroll', scrollHide)
    }
  }, [ismenu])
  const menuAction = (sliderval) => {
    if (sliderval) {
      setslider(sliderval)
      setTimeout(() => {
        setanimslider(sliderval)
      }, 200)
      //document.documentElement.style.overflowY = 'hidden'
    } else {
      //document.documentElement.style.overflowY = ''
      setanimslider(sliderval)
      setTimeout(() => {
        setslider(sliderval)
      }, 300)
    }
  }

  return (
    <section
      className={
        isactive ? 'new-nav nav-section active' : ' new-nav nav-section'
      }
    >
      <div className={slider ? 'mobile-slider active' : 'mobile-slider'}>
        <div className={animslider ? 'slider-menu active' : 'slider-menu'}>
          <div className="close-menu" onClick={() => menuAction(false)}>
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="book-mobile" />
          <ul>
            <li onClick={() => setmenu(!menu)}>
              <p className='has-text-weight-bold'>Our Services </p>
              <span>
                <FontAwesomeIcon
                  icon={faChevronDown}
                  flip={menu ? 'vertical' : 'horizontal'}
                />
              </span>
            </li>
            <div className={menu ? 'active service-icon' : 'service-icon'}>
              {menuItems.map(({ name, page, ext }) => (
                <Link key={page} to={`/${page}`}>
                  <img
                    width="37px"
                    height="33px"
                    src={serviceIconLookup(name)}
                    alt={name}
                    style={{ marginRight: 5 }}
                    loading="lazy"
                  />
                  {name}
                </Link>
              ))}
            </div>
            <li>
              <Link to="/about-us/">About Us</Link>
            </li>
            <li>
              <Link to="/blogs">
                Blogs
              </Link>
            </li>
            <li>
              <button onClick={() => enableModal(true)} className="main-btn">
                Book Now
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="container">
        <nav>
          <img
            src={Logo}
            alt="Portea"
            onClick={() => (window.location.href = '/')}
          />
          <div className="mobilemenu">
            <span className="navbar-item nav-phone">
              <a
                href="tel:18001212323"
                className="navbar-link number-action is-arrowless"
              >
                <img src={india} alt="" />
                <FontAwesomeIcon icon={faPhone} />
                1800 121 2323
              </a>
            </span>
            <span className="menu-burger" onClick={() => menuAction(true)}>
              <span />
              <span />
              <span />
            </span>
          </div>
          <ul>
            <li>
              <div
                className="navbar-item has-dropdown is-hoverable"
                ref={navbarRef}
              >
                <span
                  className="navbar-link"
                  onClick={() => setismenu(!ismenu)}
                  onMouseEnter={() => setismenu(true)}
                >
                  Our Services
                </span>
                {ismenu && (
                  <div className="navbar-dropdown service-icon">
                    {menuItems.map(({ name, page, ext }) => (
                      <Link key={page} to={`/${page}`}>
                        <img
                          width="37px"
                          height="33px"
                          src={serviceIconLookup(name)}
                          alt={name}
                          style={{ marginRight: 15 }}
                          loading="lazy"
                        />
                        {name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </li>
            <li>
              <Link to="/about-us/">About Us</Link>
            </li>
            <li>
              <Link to="/blogs">
                Blogs
              </Link>
            </li>
            <li>
              <span className="navbar-item nav-phone">
                <a
                  href="tel:18001212323"
                  className="navbar-link number-action is-arrowless"
                >
                  <img src={india} alt="" />
                  <FontAwesomeIcon icon={faPhone} />
                  1800 121 2323
                </a>
              </span>
            </li>
            <li>
              <button onClick={() => enableModal(true)} className="main-btn">
                Book Now
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  )
}
export default NavBar
